
































































import { Vue, Component, Watch, Prop } from "vue-property-decorator";
import _ from "@/boot/lodash";

// Types
import { INotificationHook } from "@/models/notifications";
import { IWebhookTrigger, IWebhookTriggerForm } from "@/models/webhooks";
import { ITemplateCategory } from "@/models/templates";

@Component
export default class WebhookCategoryTriggersSelector extends Vue {
  // Props

  @Prop({ required: true })
  public value!: IWebhookTriggerForm["subscriptions"];

  @Prop({ required: true })
  public categoryHooks!: INotificationHook[];

  @Prop({ required: true })
  public categoryId!: ITemplateCategory["id"];

  @Prop({ required: true })
  public isDisabled!: boolean;

  // Data

  public query = "";
  public useAllTriggers = true;
  public selectedTriggersIds: IWebhookTrigger["id"][] = [];

  // Life-cycle methods

  public created() {
    if (this.isUsingAll) {
      this.selectedTriggersIds = _.map(
        this.categoryHooks,
        categoryHook => categoryHook.id
      );
      return;
    }

    this.selectedTriggersIds = _.map(
      this.value,
      categoryHook => categoryHook.hook_id
    ) as IWebhookTrigger["id"][];
    this.useAllTriggers = false;
  }

  // Methods

  public toggleUseAll() {
    this.useAllTriggers = !this.useAllTriggers;
    this.handleSwitcher(this.useAllTriggers);
  }

  public handleSwitcher(value) {
    this.clearFilter();
    this.$set(
      this,
      "selectedTriggersIds",
      value ? _.map(this.categoryHooks, categoryHook => categoryHook.id) : []
    );
  }

  public handleSelection() {
    if (this.useAllTriggers !== this.allSelected)
      this.useAllTriggers = this.allSelected;
  }

  public clearFilter() {
    this.query = "";
  }

  // Computed

  public get isUsingAll() {
    return _.some(this.value, trigger => {
      return _.isEmpty(trigger.hook_id);
    });
  }

  public get filteredCategoryHooks() {
    const query = this.query.trim().toUpperCase();

    const filtered = query.length
      ? this.$_.filter(this.categoryHooks, ({ name }) =>
          name
            .trim()
            .toUpperCase()
            .includes(query)
        )
      : this.categoryHooks;
    return this.$_.orderBy(filtered, ["name"], ["asc"]);
  }

  public get selectionResults() {
    if (this.useAllTriggers) return [{ category_id: this.categoryId }];

    return _.map(this.selectedTriggersIds, selectedTriggerId => {
      return {
        hook_id: selectedTriggerId
      };
    });
  }

  public get allSelected() {
    return this.selectionResults.length === this.categoryHooks.length;
  }

  // Watchers

  @Watch("selectedTriggersIds")
  public onSelectedTriggersIdsChange() {
    this.$emit("input", this.selectionResults);
  }
}
